import { Transition, Disclosure } from '@headlessui/react'
import { ArrowCircleRightIcon } from '@heroicons/react/outline'
import Link from 'next/link'
import Image from 'next/image';

export default function Faq() {
  return (
    <section className="relative bg-white bg-center overflow-hidden font-['Inter']">
      <div className="bg-transparent">
        <div className="relative pt-16 pb-12">
          <div className="container px-4 md:px-0 mx-auto max-w-3xl lg:max-w-5xl">
            <div className="relative flex flex-wrap justify-center -mx-4">
              <div className="w-full px-4 mb-12 md:mb-0 text-center">
                <h1
                  className="main-top-title mb-16">
                  Frequently Asked Questions<br />
                </h1>
                <div>
                  <div className="w-full px-10">
                    <div className="flex flex-col md:items-left items-center justify-center text-left">
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Can you help us build custom CKAN extensions or plugins?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">Yes, our team of experienced developers can create custom CKAN extensions and plugins tailored to your specific needs.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Can you provide assistance with data visualization and analytics?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">Yes, we offer a range of data visualization and analytics services, including custom data visualization development and data analytics consulting.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Can you help me plan and execute a CKAN migration or upgrade?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow" />
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">Yes, our team has extensive experience with CKAN migration and upgrades and can assist you with planning and executing a successful migration or upgrade
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Can you provide training and support for my CKAN administrators and users?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      Yes, we provide training and support services designed to meet the needs of both technical and non-technical users. We offer on-site training, webinars, workshops, online documentation, and other materials to help your team use CKAN with confidence. We also provide ongoing support and guidance to ensure that your team has the knowledge and resources they need to use CKAN effectively.<br /><br />
                                      In addition to our standard training and support services, we have created an online training course specifically designed to train both technical and non-technical staff in understanding and effectively utilizing what CKAN has to offer. <Link className="underline" href="/ckan-training">See more</Link>
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">How do you approach CKAN documentation and knowledge transfer?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      At Datopian we have a well-established knowledge transfer strategy that provides the different user groups - both technical and non-technical - with the information, skills and knowledge they will need. Our knowledge transfer strategy combines technology, culture, measurement, and infrastructure. The main objectives of every project are not only to build sustainable platforms but also to ensure that our clients have sufficient training and support to continue running the services efficiently once our engagement has concluded.<br /><br />
                                      We have leveraged all our skills and resources to enhance our clients’ capabilities by making coaching, upskilling, and effective knowledge transfer an organization-wide mission. We facilitate knowledge sharing using efficient, readily available, and easy-to-adopt means. We consider the role technology plays in capturing and disseminating valuable knowledge and subject matter expertise at the point of need, that’s why we incorporate different formats into our coaching programs. The delivery method for transferring knowledge is a combination of video-based live workshops with Q&A sessions, hand-over documents, pre-recorded videos, online course materials, tutorials, and regular technical support.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}